module.exports = __webpack_public_path__ + "static/media/bnr10.164fd626.jpg";